export enum WidgetLeadEnum {
    OPENS = 'OPENS',
    PLANNEDS_TODAY = 'PLANNEDS_TODAY',
    DELAYEDS = 'DELAYEDS',
    WITHOUT_ACTIVITIES = 'WITHOUT_ACTIVITIES',
}